import type { ReactNode } from 'react';

import type { MenuItem } from '@/consts/navigation';
import type { SearchResult } from '@/features/header/hooks/useSearchResults';
import { normalizeString } from '@/utils/string';
import { t } from 'i18next';

export const buildResults = (
  menuItemLabel: string,
  menuItemIcon: ReactNode,
  children: MenuItem[] | undefined
): SearchResult[] => {
  if (!children) return [];

  return children
    .filter((menuItem): menuItem is typeof menuItem & { to: string } => typeof menuItem.to === 'string')
    .map((menuItem) => ({
      category: menuItemLabel,
      label: t(menuItem.text),
      to: menuItem.to,
      icon: menuItemIcon
    }));
};

export const getFilteredChildren = (menuItem: MenuItem, regex: RegExp) => {
  return menuItem.children?.filter(
    (menuItem) => typeof menuItem.to === 'string' && regex.test(normalizeString(t(menuItem.text)))
  );
};
